export default function RegistrationComplete() {
  return (
    <div style={{ textAlign: "center" }}>
      <h2>Registration Complete</h2>
      <p>
        Your registration has been submitted.  
        A CloudGenomics administrator will review your request shortly.
      </p>
      <p>
        You will receive an approval or denial email once the review is complete.
      </p>
    </div>
  );
}